import React, { forwardRef } from 'react';
import styles from './Title.module.scss';

const Title = forwardRef(({ children, className = '', TagWrapper = 'span', showPrefix = true, ...props }, ref) => {
  return (<TagWrapper ref={ref} className={`${styles.title} ${className} ${showPrefix ? styles.prefix : ''}`} {...props}>
    {children}
  </TagWrapper>);
});

export default Title;